import { useEffect, useState } from "react";
import GridPage from "../components/GridPage";
import MainLayout from "../components/MainLayout";
import { companyPartnerMapingHeader } from "../components/HeaderAttribute";
import { BindAPI } from "../services/APIConnection";

const CompanyPartnerMapping = () => {
  const [bindCompanyPartnerMappingDatas, setBindCompanyPartnerMappingDatas] = useState([]);
  useEffect(() => {
    FetchData();
  }, []);

  const FetchData = async () => {
    const response = await BindAPI("ReportAPI/ReportCompanyPartnerMapping");
    setBindCompanyPartnerMappingDatas(response.data.Table);
  };
  return (
    <MainLayout pageName={"2"}>
      <div>
        <GridPage
          title="Company - Partner Mapping"
          header={companyPartnerMapingHeader}
          records={bindCompanyPartnerMappingDatas}
          blockView={false}
          addView={true}
        />
      </div>
    </MainLayout>
  );
};

export default CompanyPartnerMapping;
